import { render, staticRenderFns } from "./AddCategory.vue?vue&type=template&id=f4e77cc8&scoped=true"
import script from "./AddCategory.vue?vue&type=script&lang=js"
export * from "./AddCategory.vue?vue&type=script&lang=js"
import style0 from "./AddCategory.vue?vue&type=style&index=0&id=f4e77cc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e77cc8",
  null
  
)

export default component.exports